import constants from 'constants/index'

const snackbarStatusTranslation = (status, isFaq = false) => {
  if (isFaq) return constants.technicalFaqs.STATUSES_LABELS_BAR_IS_FAQ[status]

  return constants.technicalFaqs.STATUSES_LABELS_BAR[status]
}

export default snackbarStatusTranslation
